import {applyMiddleware, createStore, compose} from "redux";
import {persistStore, autoRehydrate} from 'redux-persist';
import {createLogger} from 'redux-logger';
import reducer from "../services";
import thunk from "redux-thunk";
import promise from "redux-promise-middleware";

const isProductionMode = process.env.NODE_ENV && process.env.NODE_ENV.trim() === 'production';
const promiseMiddleware = promise();

let middleware = null;


const middlewares = [thunk, promiseMiddleware];

if (isProductionMode) {
	middleware = compose(applyMiddleware(...middlewares), autoRehydrate());
} else {
	const loggerMiddleware = createLogger();
	const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
	//!LOGLESS &&
	middlewares.push(loggerMiddleware);
	middleware = composeEnhancers(applyMiddleware(...middlewares), autoRehydrate());
}

const ApplicationStore = createStore(reducer, undefined, middleware);
persistStore(ApplicationStore, {whitelist: ["user", "pageState", "role", "provider"]});
export default ApplicationStore;



// WEBPACK FOOTER //
// ./src/opencell/framework/ApplicationStore.js